import { Truck } from 'lucide-react';
import { APP_CONFIG } from '../../core/config';
import { NAV_ITEMS, visibleNavItems } from './nav-items';
import type { NavItemId } from './nav-items';
import type { User } from '../../types/user';

interface SideNavProps {
  active: NavItemId;
  onNavigate: (id: NavItemId) => void;
  /** Whose sidebar it is — a screen they may not reach is not listed. */
  user: User;
}

/** Desktop navigation: the same map as the tab bar, as a fixed RTL sidebar. */
export function SideNav({ active, onNavigate, user }: SideNavProps) {
  const items = visibleNavItems(user, NAV_ITEMS);

  return (
    <aside
      aria-label="ניווט ראשי"
      data-print="hide"
      className="hidden lg:flex lg:flex-col print:hidden w-60 shrink-0 border-l border-line bg-panel min-h-screen sticky top-0"
    >
      <div className="flex items-center gap-3 p-5 border-b border-line">
        <div className="w-10 h-10 rounded-xl bg-brand-50 text-brand-500 flex items-center justify-center">
          <Truck size={20} aria-hidden />
        </div>
        <div className="min-w-0">
          <p className="font-bold leading-tight truncate">{APP_CONFIG.appName}</p>
          <p className="text-xs text-ink/50" data-dir="ltr">
            v{APP_CONFIG.version}
          </p>
        </div>
      </div>

      <ul className="p-3 space-y-1">
        {items.map((item) => {
          const Icon = item.icon;
          const isActive = item.id === active;
          return (
            <li key={item.id}>
              <button
                type="button"
                onClick={() => onNavigate(item.id)}
                aria-current={isActive ? 'page' : undefined}
                className={[
                  'w-full flex items-center gap-3 rounded-xl px-3 py-2.5 text-sm transition-colors',
                  isActive
                    ? 'bg-brand-50 text-brand-700 font-semibold'
                    : 'text-ink/70 hover:bg-canvas hover:text-ink',
                ].join(' ')}
              >
                <Icon size={18} aria-hidden />
                {item.label}
              </button>
            </li>
          );
        })}
      </ul>
    </aside>
  );
}
